
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'hub-picker-ui',
  currentProjectVersion: 'static-1.13887',
  depVersions: {
  "hub-picker-ui": "static-1.13887",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8229",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11679",
  "I18n": "static-7.1650",
  "jasmine-runner": "static-1.6659",
  "quartz": "static-1.7302",
  "react-dlb": "static-1.83",
  "reselect": "static-3.8",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.852",
  "data-fetching-client": "static-1.9862",
  "demo-data-generator": "static-1.385",
  "flux-actions": "static-1.355",
  "foundations-components": "static-1.8313",
  "hub-http": "static-1.6422",
  "hub-pickers-lib": "static-1.13867",
  "HubStyle": "static-2.11986",
  "icons": "static-2.668",
  "immutable": "static-2.79",
  "quartz-auth": "static-1.977",
  "quartz-config": "static-1.1080",
  "quartz-core": "static-1.6521",
  "quartz-routing": "static-1.732",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16910",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5483",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "StyleGuideUI": "static-3.491",
  "ui-images": "static-2.1213",
  "UIComponents": "static-3.8625",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3542",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3579",
  "quartz-webpack": "static-1.3526",
  "bend-plugin-quartz-routing": "static-1.380",
  "HeadJS": "static-2.781",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3340",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "foundations-theming": "static-1.4649",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4528",
  "sassPrefix": "static-1.160",
  "apollo-stack-hubspot": "static-3.89",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "foundations-assets": "static-1.5080",
  "rpc-client-utils": "static-1.4863",
  "usage-tracker": "static-1-session-replay-endpoint-migration.6",
  "bend-plugin-foundations-components": "static-1.4582",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2365",
  "hs-story-utils": "static-1.9631",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2344",
  "ui-fonts": "static-1.941",
  "hs-locale-management": "static-1.223",
  "ReduxMessenger": "static-2.10570",
  "hub-http-shared-msw-handlers": "static-1.10450",
  "hubspotter-http": "static-1.4793",
  "hubspotter-http-shared-msw-handlers": "static-1.10448",
  "quick-fetch": "static-1.4060",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-head": "static-1.967",
  "quartz-i18n": "static-1.977",
  "quartz-test": "static-1.977",
  "quartz-tracking": "static-1.681",
  "trellis-components": "static-1.2363",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.6",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "bender-build-tools": "static-1.3323",
  "bend-plugin-foundations-theming": "static-1.3132",
  "foundations-theming-base": "static-1.3634",
  "stylex": "static-1.37",
  "bend-plugin-chirp-manifest": "static-1.273",
  "chirp-fetch": "static-1.2092",
  "ts-schema": "static-1.4222",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.6",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1158",
  "tanstack-virtual": "static-1.33",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "hub-picker-ui": "/hub-picker-ui/static-1.13887",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8229",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11679",
  "I18n": "/I18n/static-7.1650",
  "jasmine-runner": "/jasmine-runner/static-1.6659",
  "quartz": "/quartz/static-1.7302",
  "react-dlb": "/react-dlb/static-1.83",
  "reselect": "/reselect/static-3.8",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.852",
  "data-fetching-client": "/data-fetching-client/static-1.9862",
  "demo-data-generator": "/demo-data-generator/static-1.385",
  "flux-actions": "/flux-actions/static-1.355",
  "foundations-components": "/foundations-components/static-1.8313",
  "hub-http": "/hub-http/static-1.6422",
  "hub-pickers-lib": "/hub-pickers-lib/static-1.13867",
  "HubStyle": "/HubStyle/static-2.11986",
  "icons": "/icons/static-2.668",
  "immutable": "/immutable/static-2.79",
  "quartz-auth": "/quartz-auth/static-1.977",
  "quartz-config": "/quartz-config/static-1.1080",
  "quartz-core": "/quartz-core/static-1.6521",
  "quartz-routing": "/quartz-routing/static-1.732",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16910",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5483",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-images": "/ui-images/static-2.1213",
  "UIComponents": "/UIComponents/static-3.8625",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3542",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3579",
  "quartz-webpack": "/quartz-webpack/static-1.3526",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.380",
  "HeadJS": "/HeadJS/static-2.781",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3340",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "foundations-theming": "/foundations-theming/static-1.4649",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4528",
  "sassPrefix": "/sassPrefix/static-1.160",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "foundations-assets": "/foundations-assets/static-1.5080",
  "rpc-client-utils": "/rpc-client-utils/static-1.4863",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.6",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4582",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2365",
  "hs-story-utils": "/hs-story-utils/static-1.9631",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2344",
  "ui-fonts": "/ui-fonts/static-1.941",
  "hs-locale-management": "/hs-locale-management/static-1.223",
  "ReduxMessenger": "/ReduxMessenger/static-2.10570",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10450",
  "hubspotter-http": "/hubspotter-http/static-1.4793",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10448",
  "quick-fetch": "/quick-fetch/static-1.4060",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-head": "/quartz-head/static-1.967",
  "quartz-i18n": "/quartz-i18n/static-1.977",
  "quartz-test": "/quartz-test/static-1.977",
  "quartz-tracking": "/quartz-tracking/static-1.681",
  "trellis-components": "/trellis-components/static-1.2363",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.6",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.6",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3132",
  "foundations-theming-base": "/foundations-theming-base/static-1.3634",
  "stylex": "/stylex/static-1.37",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.273",
  "chirp-fetch": "/chirp-fetch/static-1.2092",
  "ts-schema": "/ts-schema/static-1.4222",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.6",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1158",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
